/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getLaunchPageActivityTable = params => {
  return axios.post(`${base}/launch_page_activity/query`, params)
}
export const getLaunchPageActivityDetail = params => {
  return axios.get(`${base}/launch_page_activity/get_${params.id}`, {params})
}
export const createLaunchPageActivityData = params => {
  return axios.post(`${base}/launch_page_activity/create`, params)
}
export const updateLaunchPageActivityData = params => {
  return axios.post(`${base}/launch_page_activity/edit_${params.id}`, params)
}
export const deleteLaunchPageActivityData = params => {
  return axios.post(`${base}/launch_page_activity/delete_${params.id}`, params)
}
export const onlineLaunchPageActivityData = params => {
  return axios.post(`${base}/launch_page_activity/online_${params.id}`, params)
}
export const offlineLaunchPageActivityData = params => {
  return axios.post(`${base}/launch_page_activity/offline_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/launch-page-activity/launch-page-activity.api.js